import React, { useEffect, useRef, useState } from "react";
import "../Style/Component/SplashScreen.css";
import add from "../Assets/Splash/plus.svg";
import placeimage from "../Assets/Splash/reviewimage.png";
import Cropper from "react-easy-crop";
import enlargeIcon from "../Assets/Splash/enlargeicon.svg";
import {
  deleteWithTokenAPI,
  getWithTokenAPI,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../Util/Api.js";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
const Splashscreen = () => {
  const screenRefs = useRef({});

  const [big, setBig] = useState("");
  const [small, setSmall] = useState("");
  const fileInputRef = useRef(null);
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const permission = auth.permission;
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [cropMode, setCropMode] = useState("crop");
  const [screens, setScreens] = useState([]);
  console.log(screens, "setScreenssetScreens");
  const [isNewScreen, setIsNewScreen] = useState(false);
  const finalScreenOrder = screens.length + 1;
  const [previewUrl, setPreviewUrl] = useState("");

  const [type, setType] = useState("user");
  const [showCrop, setShowCrop] = useState(false);
  const [cropImage, setCropImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const onCropComplete = (_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const [selectedScreen, setSelectedScreen] = useState(1);
  const selectedData = screens.find((item) => item.screenNo === selectedScreen);

  const newOrder =
    screens.length > 0 ? Math.max(...screens.map((s) => s.screenNo)) + 1 : 1;

  useEffect(() => {
    if (!selectedData) return;
    if (selectedData.isTemp) {
      return;
    }

    setBig(selectedData?.title?.en || "");
    setSmall(selectedData?.subtitle?.en || "");
  }, [selectedData]);

  useEffect(() => {
    if (!screens.length) return;

    if (isNewScreen) return;

    setSelectedScreen(screens[0].screenNo);
  }, [screens, isNewScreen]);

  useEffect(() => {
    return () => {
      if (selectedImage?.preview) {
        URL.revokeObjectURL(selectedImage.preview);
      }
    };
  }, [selectedImage]);

  // useEffect(() => {
  //   return () => {
  //     if (previewImage) {
  //       URL.revokeObjectURL(previewImage);
  //     }
  //   };
  // }, [previewImage]);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // if (file.size > 2 * 1024 * 1024) {
    //   SafeToast.error("Image must be less than 2MB");
    //   return;
    // }

    try {
      const previewUrl = URL.createObjectURL(file);
      console.log(previewUrl, "PREVIEWURL before cropping");
      setSelectedImage(file);
      setCropImage(previewUrl);
      setCropMode("crop");
      setShowCrop(true); // ✅ upload happens AFTER crop
    } catch {
      // SafeToast.error("Image upload failed");
    }
  };

  useEffect(() => {
    const node = screenRefs.current[selectedScreen];
    if (node) {
      node.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedScreen]);

  useEffect(() => {
    if (uploadedImageUrl) {
      console.log("STATE UPDATED 👉", uploadedImageUrl);
    }
  }, [uploadedImageUrl]);

  useEffect(() => {
    fetchsplashscreen();
  }, [token, type]);
  const fetchsplashscreen = async () => {
    try {
      const selectedType = type === "approve" ? "approve" : type;

      const response = await getWithTokenAPI(
        token,
        `/intro_screen/list?type=${selectedType}`,
      );

      const data = Array.isArray(response?.data) ? response.data : [];
      if (data) {
        setScreens(data);
      }
    } catch {
      console.log("Error in fetching Limit Api");
    }
  };

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("files", file);
    const res = await postWithoutTokenAPI(
      `/upload_image?userId=${adminId}&type=admin`,
      formData,
      true,
    );
    console.log("UPLOAD RESPONSE 👉", res);
    setUploadedImageUrl(res?.data?.[0]?.fileUrl);
    return res?.data?.[0]?.fileUrl;
  };

  const handleUpdate = async () => {
    try {
      if (!big || !small) {
        toast.error("Title and subtitle are required");
        return;
      }

      console.log(selectedData, "selectedDataselectedData");
      const payload = {
        screenNo: selectedScreen,
        title: { en: big },
        subtitle: { en: small },
        imageUrl: uploadedImageUrl || selectedData?.imageUrl,
        platform: "both",
        isActive: true,
        type: [type],
        ctaType: "skip",
      };
      let res;
      // 🟢 NEW SCREEN → POST
      if (!selectedData?._id || selectedData?.isTemp) {
        res = await postWithTokenAPI(token, "/intro_screen/create", payload);
      } else {
        res = await putWithTokenAPI(
          token,
          `/intro_screen/update?id=${selectedData._id}`,
          payload,
        );
      }

      if (res?.statusCode === 200 || res?.statusCode === 201) {
        toast.success("Splash screen saved successfully");
        setUploadedImageUrl("");

        // Refresh screens from backend
        const refreshed = await getWithTokenAPI(
          token,
          `/intro_screen/list?type=${type}`,
        );

        setScreens(refreshed?.data || []);
        setIsNewScreen(false);
      } else {
        toast.error(res?.message || "Save failed");
      }
    } catch {
      console.log("Error");
      toast.error("Something went wrong");
    }
  };

  const AddScreen = () => {
    const newOrder = screens.length + 1;

    const tempScreen = {
      screenNo: newOrder,
      title: { en: "" },
      subtitle: { en: "" },
      imageUrl: placeimage,
      platform: "both",
      isActive: true,
      type: [type],
      isTemp: true,
    };

    setScreens((prev) => [...prev, tempScreen]);
    setSelectedScreen(newOrder);

    // ✅ defaults stay
    setBig("");
    setSmall("");
    setSelectedImage(null);
    setIsNewScreen(true);
  };

  const handleDeleteScreen = () => {
    Swal.fire({
      title: "Delete Intro Screen?",
      text: "Sure to delete this Intro Screen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(186, 28, 28)",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handledelete(); // your function
      }
    });
  };
  const handledelete = async () => {
    if (!selectedData) return;

    // 🟡 If temp screen → just remove locally
    if (selectedData.isTemp) {
      setScreens((prev) =>
        prev.filter((item) => item.screenNo !== selectedScreen),
      );
      setSelectedScreen(1);
      setIsNewScreen(false);
      return;
    }

    try {
      const res = await deleteWithTokenAPI(
        token,
        `/intro_screen/delete?id=${selectedData._id}`,
      );

      if (res?.statusCode === 200) {
        toast.success("Screen deleted successfully");

        const refreshed = await getWithTokenAPI(
          token,
          `/intro_screen/list?type=${type}`,
        );
        setScreens(refreshed?.data || []);
        setSelectedScreen(1);
      } else {
        toast.error("Delete failed");
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  const getCroppedImg = async (imageSrc, crop) => {
    const image = new Image();
    image.crossOrigin = "anonymous"; // ✅ REQUIRED
    image.src = imageSrc;

    await new Promise((res, rej) => {
      image.onload = res;
      image.onerror = rej;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(new File([blob], "cropped.jpg", { type: "image/jpeg" }));
      }, "image/jpeg");
    });
  };

  return (
    <div className="splashscreen">
      <div className="heading">
        <span>Splash Screen Update</span>
      </div>
      <div className="splashscreenbody">
        <div className="roleselect">
          <span
            onClick={() => setType("user")}
            style={{
              borderBottom: `${type === "user" ? `2px solid var(--primary)` : ""}`,
            }}
          >
            Customer
          </span>
          <span
            onClick={() => setType("driver")}
            style={{
              borderBottom: `${type === "driver" ? `2px solid var(--primary)` : ""}`,
            }}
          >
            Driver
          </span>
          <span
            onClick={() => setType("approve")}
            style={{
              borderBottom: `${type === "approve" ? `2px solid var(--primary)` : ""}`,
            }}
          >
            Driver Approval
          </span>
          {/* <button type="submit">
            <img src={add}></img>Add New
          </button> */}
        </div>
        <div className="splashscreens">
          {screens.map((item) => (
            <div
              ref={(el) => (screenRefs.current[item.screenNo] = el)}
              className={`spscreenimage ${
                item.screenNo === selectedScreen ? "selected" : ""
              } ${item.isTemp ? "placeholder" : ""}`}
              key={item._id || item.screenNo}
              onClick={() => setSelectedScreen(item.screenNo)}
            >
              {item.screenNo === selectedScreen &&
                permission?.splash_screen?.delete && (
                  <span
                    className="delete-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteScreen();
                    }}
                  >
                    ✕
                  </span>
                )}
              <img src={item.imageUrl} />{" "}
              {item.screenNo === selectedScreen && (
                <div
                  className="enlarge-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCropMode("view");
                    setCropImage(
                      previewUrl || uploadedImageUrl || item.imageUrl,
                    );
                    setShowCrop(true);
                  }}
                >
                  <img src={enlargeIcon} />
                </div>
              )}
            </div>
          ))}
          {/* {type === "dealer" && finalscreen?.[0] && (
            <div
              className={`spscreenimage ${selectedScreen === finalScreenOrder ? "selected" : ""
                }`}
              onClick={() => setSelectedScreen(finalScreenOrder)}
            >
              {selectedScreen === finalScreenOrder && (
                <span
                  className="delete-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    SafeToast.error("Approved screen cannot be deleted");
                  }}
                >
                  ✕
                </span>
              )}
              <img src={finalscreen[0].imageUrl} />
            </div>
          )} */}
        </div>

        <div className="splashscreensform">
          <div
            style={{
              width: "40%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex" }}>
              <label>Screen</label>
              <select
                value={selectedScreen}
                onChange={(e) => setSelectedScreen(Number(e.target.value))}
                style={{ height: "35px" }}
              >
                {type !== "approve" ? (
                  screens.map((item) => (
                    <option key={item._id} value={item.screenNo}>
                      {item.screenNo}
                    </option>
                  ))
                ) : (
                  <option value={1}>1</option>
                )}

                {/* {type === "dealer" && (
                  <option value={finalScreenOrder}>{finalScreenOrder}</option>
                )} */}
              </select>
            </div>
            {type !== "approve" && permission?.splash_screen?.create && (
              <button type="submit" className="submit" onClick={AddScreen}>
                <img src={add}></img>Add Screen
              </button>
            )}
          </div>
          {permission?.splash_screen?.update && (
            <div className="uimagebg">
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
                accept="image/*"
              />

              <input
                type="text"
                value={selectedImage?.name || ""}
                placeholder="No image selected"
                readOnly
              />

              <button onClick={handleUploadClick}>Upload Image</button>
            </div>
          )}

          <div className="splashscreencontent">
            <span>Splash Screen Content</span>
            <div className="smbtn">
              <label>Main Content</label>
              <input
                type="text"
                value={big}
                onChange={(e) => setBig(e.target.value)}
                placeholder="Main text"
                style={{ width: "80%" }}
              />
            </div>
            <div className="smbtn">
              <label>sub-content</label>
              <input
                type="text"
                className="splashsmall"
                value={small}
                onChange={(e) => setSmall(e.target.value)}
                placeholder="Sub text"
              />
              {permission?.splash_screen?.update && (
                <button onClick={handleUpdate}>Update</button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showCrop && (
        <div className="crop-modal">
          <div className="crop-container">
            <div className="crop-header">
              <h3>{cropMode === "crop" ? "Crop Image" : "Enlarged Image"}</h3>
            </div>
            <Cropper
              image={cropImage}
              crop={crop}
              zoom={zoom}
              aspect={9 / 16}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
              disabled={cropMode === "view"}
            />

            <div className="crop-actions">
              <button onClick={() => setShowCrop(false)}>Cancel</button>
              {cropMode === "crop" && (
                <button
                  onClick={async () => {
                    if (!croppedAreaPixels) {
                      // SafeToast.error("Please crop the image");
                      return;
                    }
                    const croppedFile = await getCroppedImg(
                      cropImage,
                      croppedAreaPixels,
                    );
                    const localPreview = URL.createObjectURL(croppedFile);
                    setPreviewUrl(localPreview);

                    setSelectedImage(croppedFile);

                    const uploadedUrl = await uploadImage(croppedFile);
                    if (!uploadedUrl) return;

                    setScreens((prev) =>
                      prev.map((screen) =>
                        screen.screenNo === selectedScreen
                          ? {
                              ...screen,
                              imageUrl: uploadedUrl,
                            }
                          : screen,
                      ),
                    );
                    setUploadedImageUrl(uploadedUrl);
                    console.log(uploadedUrl, "UPLOADEDURL");
                    console.log(uploadedImageUrl, "UPLOADEDIMAGEURL");
                    setShowCrop(false);
                    // SafeToast.success("Image cropped & uploaded");
                  }}
                >
                  Save
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Splashscreen;
